var alignSelfMap = {
    end: "flex-end",
    start: "flex-start",
    center: "center",
    stretch: "stretch",
};
export default (function (_a) {
    var alignSelf = _a.alignSelf;
    return alignSelf in alignSelfMap && "align-self: ".concat(alignSelfMap[alignSelf], ";");
});
